<qai-results-tab
  [title]="'results.MESSAGING' | transloco"
  [score]="overallScore"
  [scoreKind]="scoreKind"
>
  <!-- V1: classic message adherence (single positive/negative strings per section) -->
  <ng-container *ngIf="!isMessageAdherenceV2">
    <ng-container *ngFor="let section of messageAdherences">
      <qai-section-header
        [subtitle]="section.title ?? ''"
        [subtitleIndicator]="getScoreIndicator(section.score)"
        [border]="true"
      />
      <qai-label *ngIf="section.message">{{ section.message }}</qai-label>
      <div class="info-blocks">
        <qai-info-block
          *ngIf="getV1PositiveItems(section).length"
          [title]="'results.WHAT_YOU_DID_WELL' | transloco"
          [items]="getV1PositiveItems(section)"
        />
        <qai-info-block
          *ngIf="getV1NegativeItems(section).length"
          [title]="'results.WHAT_TO_IMPROVE' | transloco"
          [items]="getV1NegativeItems(section)"
        />
      </div>
    </ng-container>
  </ng-container>

  <!-- V2: message adherence v2 with fact arrays per section -->
  <ng-container *ngIf="isMessageAdherenceV2">
    <ng-container *ngFor="let section of flattenedSections">
      <qai-section-header
        [subtitle]="section.title"
        [subtitleIndicator]="
          getV2ScoreIndicator(section.numIncludedCorrectly, section.totalNum)
        "
        [border]="true"
      />
      <div class="info-blocks">
        <qai-info-block
          [title]="'results.TALKING_POINTS_COVERED' | transloco"
          [items]="getFactTexts(section.positives)"
          [itemIcon]="checkIcon"
        />
        <qai-info-block
          [title]="'results.TALKING_POINTS_MISSED' | transloco"
          [items]="getFactTexts(section.negatives)"
          [itemIcon]="crossIcon"
        />
      </div>
    </ng-container>
  </ng-container>
</qai-results-tab>
